import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

// Types
import { User } from 'Shared/constants/types';
import { BAFactorShapeType } from 'Shared/components/BehavioralPatternGraph/FactorShape.service';

type Props = {
  user: User;
  shape?: BAFactorShapeType;
};

export const useBaProfileDrawer = ({ user, shape }: Props) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const handleOpenBaDrawer = useCallback(() => {
    history.replace({ pathname, state: { view: 'use-ba-snapshot', userSlug: user.slug, shape } });
  }, []);

  return {
    handleOpenBaDrawer,
  };
};
